import React from "react";
import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import {
  MarketingHeader, MarketingFooter, MarketingBackdrop,
} from "@/components/MarketingShell";

export default function AboutPage() {
  const breadcrumb = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home",  "item": "https://www.powerbuilt.sx/" },
      { "@type": "ListItem", "position": 2, "name": "About", "item": "https://www.powerbuilt.sx/about" },
    ],
  };
  return (
    <MarketingBackdrop>
      <SEO
        path="/about"
        title="About PowerBuilt — Sint Maarten Solar &amp; Electrical Contractor"
        description="PowerBuilt is a Sint Maarten contractor delivering solar, electrical and system maintenance services with a digital-first customer workspace."
        jsonLd={breadcrumb}
      />
      <MarketingHeader />

      <main className="relative z-10 max-w-3xl mx-auto px-6 pt-8 md:pt-16 pb-16">
        <nav aria-label="Breadcrumb" className="text-xs text-white/50 mb-6">
          <Link to="/" className="hover:text-white">Home</Link> <span className="mx-1">/</span> <span className="text-white/70">About</span>
        </nav>

        <article>
          <p className="overline text-[#C9A356] mb-4">About</p>
          <h1 className="text-4xl sm:text-5xl font-heading font-medium tracking-tight leading-[1.1]">
            One contractor. One account. The whole project.
          </h1>

          <p className="mt-8 text-lg text-slate-300 leading-relaxed">
            PowerBuilt is a Sint Maarten contractor delivering <Link className="underline decoration-[#C9A356]/60 hover:decoration-[#C9A356]" to="/solar">solar power</Link>, <Link className="underline decoration-[#C9A356]/60 hover:decoration-[#C9A356]" to="/electrical">electrical work</Link> and <Link className="underline decoration-[#C9A356]/60 hover:decoration-[#C9A356]" to="/maintenance">ongoing system maintenance</Link> for homes and businesses across the island. We build systems that hold up to the climate, and we back them with a digital workspace so customers can follow every step.
          </p>

          <h2 className="font-heading text-2xl mt-14 mb-3">How PowerBuilt is different</h2>
          <ul className="space-y-3 text-slate-300 list-disc pl-5 marker:text-[#C9A356]">
            <li><strong className="text-white">One team, end-to-end.</strong> Consultation, design, permits, installation and after-sales service — all under one project number.</li>
            <li><strong className="text-white">Digital by default.</strong> Every customer gets a private PowerBuilt account with proposals, invoices, project status, monitoring and service requests in one place.</li>
            <li><strong className="text-white">Built to last.</strong> We install marine-grade mounting, LFP battery chemistry and code-compliant electrical work — because "cheap" in the Caribbean gets expensive fast.</li>
          </ul>

          <h2 className="font-heading text-2xl mt-14 mb-3">Where we work</h2>
          <p className="text-slate-300 leading-relaxed">
            PowerBuilt serves the Dutch and French sides of the island. Our workshop is in Cole Bay, Sint Maarten, and we handle projects from single-panel installs to whole-house systems.
          </p>

          <div className="mt-12 flex flex-wrap gap-4">
            <Link to="/contact"  className="btn-accent text-base px-7 py-3">Start a project</Link>
            <Link to="/impact"   className="px-7 py-3 rounded-md font-medium text-white border-2 border-white/30 hover:bg-white/10 transition">Our impact</Link>
          </div>
        </article>
      </main>

      <MarketingFooter />
    </MarketingBackdrop>
  );
}
